export const nameRules = [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		rule: 'minLength',
		value: 1,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'maxLength',
		value: 30,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'customRegexp',
		value: /^(?=.*[A-Za-zА-ЯЁа-яё])[A-Za-zА-ЯЁа-яё'’]+(?:[A-Za-zА-ЯЁа-яё'’ -]*[A-Za-zА-ЯЁа-яё'’]+)?$/,
		errorMessage: 'Неверный формат',
	},
];
export const nameRulesFormat = [
	{
		rule: 'minLength',
		value: 1,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'maxLength',
		value: 30,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'customRegexp',
		value: /^(?=.*[A-Za-zА-ЯЁа-яё])[A-Za-zА-ЯЁа-яё'’]+(?:[A-Za-zА-ЯЁа-яё'’ -]*[A-Za-zА-ЯЁа-яё'’]+)?$/,
		errorMessage: 'Неверный формат',
	},
];
export const emailRules = [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		rule: 'email',
		errorMessage: 'Неверный формат',
	},
];
export const emailRulesFormat = [
	{
		rule: 'email',
		errorMessage: 'Неверный формат',
	},
];
export const getTelRules = (inputIdSelector) => [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		validator: (value, fields) => {
			const input = fields[inputIdSelector]?.elem;
			return value.replace(/\D/g, '').length > input.dataset.placeholder?.replace(/\D/g, '').length - 1;
		},
		errorMessage: 'Неверный формат',
	},
];
export const birthdateRules = [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		validator: (value) => {
			return value.length > 9;
		},
		errorMessage: 'Неверный формат',
	},
];
export const birthdateRulesFormat = [
	{
		validator: (value) => {
			return value.length > 9;
		},
		errorMessage: 'Неверный формат',
	},
];
export const addressRules = [
	{
		rule: 'customRegexp',
		value: /^(?![.,\-"'()/&]+$)[А-ЯЁа-яёA-Za-z0-9 .,\-"'()/&]+$/,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'minLength',
		value: 1,
		errorMessage: 'Неверный формат',
	},
];
export const addressRulesFormat = [
	{
		rule: 'customRegexp',
		value: /^(?![.,\-"'()/&]+$)[А-ЯЁа-яёA-Za-z0-9 .,\-"'()/&]+$/,
		errorMessage: 'Неверный формат',
	},
];
